import { render, staticRenderFns } from "./focused-breathing-a45.vue?vue&type=template&id=12cdb4f2&"
import script from "./focused-breathing-a45.vue?vue&type=script&lang=js&"
export * from "./focused-breathing-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports